<template>
  <div>
    <div
      class="flex h-screen overflow-auto pt-[68px] pb-10"
    >
      <div class="my-auto w-full">
        <div class="bg-white pt-1 rounded victors-fixed-width mx-auto gap-y-0">
          <div class="w-full px-5 flex justify-between items-center">
            <img
              class="inline-block"
              width="77"
              height="auto"
              src="@/assets/images/video-editor-logo.png"
              alt="video-editor"
            >
            <button
              @click="onCancelClick"
            >
              <i class="pi pi-times cursor-pointer text-gray-600 text-lg" />
            </button>
          </div>

          <div class="gap-7 p-5 pt-0 gap-y-px ">
            <div class="flex w-full mt-2">
              <div class="w-2/3 victors-fixed-video relative mr-2">
                <HiPlayer @player="p => player = p" @timeupdate="onPreviewTimeUpdate"/>
                <div class="pr-3 mt-8">
                  <div class="w-full">
                    <div class="text-black-victor font-bold text-base select-none">
                      Trim
                    </div>
                    <div class="mt-2">
                      <VideoInputSlider
                        v-if="ffmpegData.video_duration"
                        v-model:model="ffmpegData.trim_interval"
                        :duration="ffmpegData.video_duration"
                        :showPicker="true"
                        :player="player"
                        duration-layout="side"
                      />
                    </div>
                  </div>

                  <div class="w-full mt-6">
                    <div
                      class="text-black-victor font-bold text-base select-none cursor-pointer"
                      @click="$refs.cloneableComponent.increment()"
                    >
                      Cut Out
                      <img
                        class="inline-block mb-1 ml-3"
                        width="15"
                        height="15"
                        src="@/assets/images/add-plus-svgrepo-com.svg"
                        alt="add-cut-out"
                      >
                    </div>

                    <CloneableCutOut
                      ref="cloneableComponent"
                      v-model:sliders="ffmpegData.cut_out_interval"
                      :min-max="ffmpegData.trim_interval"
                      :player="player"
                      class="mt-2 max-h-32 overflow-y-scroll"
                    />
                  </div>
                </div>
              </div>
              <div class="w-1/3 pl-3">
                <div class="mb-2">
                  <EditorTemplates :options="ffmpegData" :watermark_image="watermark_image"  @templateChanged="templateChanged"/>
                </div>
                <div class="space-y-2">
                  <button
                    class="w-full flex items-center justify-between px-2 py-2 rounded bg-gray-100 text-xs font-semibold text-gray-700"
                    @click="toggleRightTab('watermark')"
                  >
                    <span>Watermark</span>
                    <i :class="[activeRightTab === 'watermark' ? 'pi pi-chevron-up' : 'pi pi-chevron-down']" />
                  </button>
                  <transition name="accordion">
                    <div v-show="activeRightTab === 'watermark'" class="p-2 bg-white border border-gray-100 rounded">
                      <WatermarkTab
                        v-model:ffmpegData="ffmpegData"
                        :previewCurrentTime="previewCurrentTime"
                        :getPreviewCurrentTime="getPreviewCurrentTime"
                        :watermarkImage="watermark_image"
                        :watermarkPositions="watermark_positions"
                        :opacityClass="opacityClass"
                        :borderClass="borderClass"
                        @update:watermarkImage="watermark_image = $event"
                      />
                    </div>
                  </transition>

                  <button
                    class="w-full flex items-center justify-between px-2 py-2 rounded bg-gray-100 text-xs font-semibold text-gray-700"
                    @click="toggleRightTab('video_fade')"
                  >
                    <span>Video Fade</span>
                    <i :class="[activeRightTab === 'video_fade' ? 'pi pi-chevron-up' : 'pi pi-chevron-down']" />
                  </button>
                  <transition name="accordion">
                    <div v-show="activeRightTab === 'video_fade'" class="p-2 bg-white border border-gray-100 rounded">
                      <VideoFadeTab v-model:ffmpegData="ffmpegData" />
                    </div>
                  </transition>

                  <button
                    class="w-full flex items-center justify-between px-2 py-2 rounded bg-gray-100 text-xs font-semibold text-gray-700"
                    @click="toggleRightTab('audio_fade')"
                  >
                    <span>Audio Fade</span>
                    <i :class="[activeRightTab === 'audio_fade' ? 'pi pi-chevron-up' : 'pi pi-chevron-down']" />
                  </button>
                  <transition name="accordion">
                    <div v-show="activeRightTab === 'audio_fade'" class="p-2 bg-white border border-gray-100 rounded">
                      <AudioFadeTab
                        v-model:ffmpegData="ffmpegData"
                        v-model:isFadeSyncWithVideo="isFadeSyncWithVideo"
                        @sync-change="onSyncFadeToggleChange"
                      />
                    </div>
                  </transition>

                  <button
                    class="w-full flex items-center justify-between px-2 py-2 rounded bg-gray-100 text-xs font-semibold text-gray-700"
                    @click="toggleRightTab('text_overlays')"
                  >
                    <span>Text Overlays</span>
                    <i :class="[activeRightTab === 'text_overlays' ? 'pi pi-chevron-up' : 'pi pi-chevron-down']" />
                  </button>
                  <transition name="accordion">
                    <div v-show="activeRightTab === 'text_overlays'" class="p-2 bg-white border border-gray-100 rounded">
                    <TextOverlaysTab
                      v-model:textOverlays="ffmpegData.text_overlays"
                      :videoDuration="ffmpegData.video_duration"
                      :watermarkPositions="watermark_positions"
                    />
                    </div>
                  </transition>
                </div>
              </div>
            </div>
            <div class="flex w-full mt-4">

              <div class="w-1/3 pl-3 relative min-h-[240px] ml-auto">
                <div class="text-white w-full h-10 mt-10">
                  <div class="grid grid-cols-2 gap-4">
                    <button
                      class="text-white h-10 bg-amber-500 rounded font-bold text-xs"
                      @click="onCancelClick"
                    >
                      Cancel
                    </button>

                    <button
                      class="text-white h-10 rounded font-bold text-xs"
                      :class="[isPreviewBtnDisabled ? 'bg-blue-400 cursor-not-allowed' : 'bg-blue-450']"
                      :disabled="isPreviewBtnDisabled"
                      @click="validateAndSubmit"
                    >
                      Preview
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EditorTemplates from "@/components/EditorTemplates.vue";

const { mapState: editorState } = createNamespacedHelpers('editor')
const { mapGetters: videoGetter } = createNamespacedHelpers('video')
const { mapActions: editorActions } = createNamespacedHelpers('editor')
const { mapActions: mapWindowActions } = createNamespacedHelpers('window')
const { mapGetters: videoSeatGetters} = createNamespacedHelpers('videoSeat')
const { mapActions: videoSeatActions } = createNamespacedHelpers('videoSeat')
const { mapMutations: previewMutations } = createNamespacedHelpers('preview')
const { mapActions: streamSeatActions } = createNamespacedHelpers('streamSeat')

import router from "../router"
import { createNamespacedHelpers } from 'vuex'
import VideoPlayer from '../components/VideoPlayer'
import CloneableCutOut from '../components/CloneableCutOut'
import WatermarkTab from "../components/editor/WatermarkTab"
import VideoFadeTab from "../components/editor/VideoFadeTab"
import AudioFadeTab from "../components/editor/AudioFadeTab"
import VideoInputSlider from "../components/VideoInputSlider"
import TextOverlaysTab from "../components/editor/TextOverlaysTab"
import HiPlayer from "@/components/Player/HiPlayer.vue";
import store from "@/vuex/store";
import {timeFromTs} from "@/helpers";

export default {
  name: 'Editor',

  components: {
    HiPlayer,
    EditorTemplates,
    // CustomModal,
    VideoPlayer,
    VideoInputSlider,
    CloneableCutOut,
    WatermarkTab,
    VideoFadeTab,
    AudioFadeTab,
    TextOverlaysTab
  },

  data: function () {
    return {
      watermark_positions: [
        [
          ['top', 'left'],
          ['top', 'center'],
          ['top', 'right']
        ],
        [
          ['center', 'left'],
          ['center', 'center'],
          ['center', 'right']
        ],
        [
          ['bottom', 'left'],
          ['bottom', 'center'],
          ['bottom', 'right']
        ]
      ],
      player: null,
      // form data
      ffmpegData: {
        video_url: null,
        video_duration: null,
        has_watermark: false,
        watermark_position: ['top', 'right'],
        watermark_horizontal_m: 15,
        watermark_vertical_m: 15,
        watermark_scale_h: 0,
        watermark_scale_w:0,
        trim_interval: [],
        watermark_interval: [],
        cut_out_interval: [],
        fade_in_model: {
          active: false,
          time: 1,
          color: '#000000',
        },
        fade_out_model: {
          active: false,
          time: 1,
          color: '#000000',
        },
        a_fade_in_model: {
          active: false,
          time: 1,
        },
        a_fade_out_model: {
          active: false,
          time: 1,
        },
        text_overlays: [],
      },
      watermark_image: null,
      // vue picture input
      custom_strings: {
        upload: '<h1>Bummer!</h1>',
        drag: 'Drag Png'
      },
      showModal: true,
      isSocketConnectionEstablished: false,
      isLoading: false,
      preview: false,
      initialVideo: null,
      isSubscribeConfirmed: null,
      isPreviewBtnDisabled: false,
      isFadeSyncWithVideo: false,
      validationInterval: null,
      activeRightTab: 'watermark',
      previewCurrentTime: 0
    }
  },

  computed: {
    ...videoSeatGetters({
      getSeatData: 'getData'
    }),
    ...editorState({
      options: state => state.options,
      is_stream: state => state.is_stream,
      tenant_id: state => state.tenant_id
    }),
    ...videoGetter({
      getVideoData: 'getData'
    }),
    ffmpegTrimInterval() {
      return this.ffmpegData.trim_interval
    },
    videoId () {
      return this.$route.params.id
    },
    opacityClass() {
      return !this.ffmpegData.has_watermark ? 'opacity-50' : 'opacity-100'
    },
    borderClass () {
      return !this.ffmpegData.has_watermark ? 'border-gray-300' : ''
    }
  },

  watch: {
    'ffmpegData.fade_in_model': {
      handler(val){
        if (this.isFadeSyncWithVideo == true) {
          Object.assign(this.ffmpegData.a_fade_in_model, val);
        }
      },
      deep: true
    },
    'ffmpegData.fade_out_model': {
      handler(val){
        if (this.isFadeSyncWithVideo == true) {
          Object.assign(this.ffmpegData.a_fade_out_model, val);
        }
      },
      deep: true
    },
    'ffmpegData.a_fade_in_model': {
      handler(val){
        if (this.isFadeSyncWithVideo == true) {
          Object.assign(this.ffmpegData.fade_in_model, val);
        }
      },
      deep: true
    },
    'ffmpegData.a_fade_out_model': {
      handler(val){
        if (this.isFadeSyncWithVideo == true) {
          Object.assign(this.ffmpegData.fade_out_model, val);
        }
      },
      deep: true
    },

  },
  /**
   * @description in created at we are starting the websocket connection
   * with server. This will be used to update status of the video
   * Also we are setting the default ffmpegData if we have them in the local storage
   */
  created: function () {
    let uri = window.location.search.substring(1);
    let params = new URLSearchParams(uri);
    this.$store.commit('editor/setTenantId', params.get('tenant_id'));
    // on created if we have video_seat_id set the video_record inside vuex and get options
    if (this.options) {
      this.ffmpegData = JSON.parse(this.options)
      this.watermark_image = this.ffmpegData.watermark_image
      if (!this.ffmpegData.text_overlays) {
        this.ffmpegData.text_overlays = []
      }
      this.normalizeTrimInterval()
    } else {
      // video options are available inside the vide vuex state
      // few options we set on default
      this.ffmpegData.video_url = this.getVideoData.url
      this.ffmpegData.video_duration = this.getVideoData.duration
      this.duration = this.getVideoData.duration
      this.normalizeTrimInterval()
    }
  },

  mounted() {
    const local = this
    store.commit('live/setLoading', false)
    if (!this.is_stream) {
      this.validationInterval = setInterval(() => {
        local.validateSeat().then(({data}) => {
          if (!data.isValid) {
            router.push({ name: 'session-expired' })
          }
        })
      }, 5000)
    } else {
      this.validationInterval = setInterval(() => {
        local.isRecordValid().then(({data}) => {
          if (!data.isValid) {
            router.push({ name: 'session-expired' })
          }
        })
      }, 5000)
    }
  },

  beforeUnmount() {
    clearInterval(this.validationInterval)
  },

  methods: {
    templateChanged(options) {
      this.ffmpegData = Object.assign(this.ffmpegData, options);
      this.watermark_image = options.watermark_image || null
    },
    onPreviewTimeUpdate (time) {
      this.previewCurrentTime = Number(time || 0)
    },
    getPreviewCurrentTime () {
      const player = this.$refs.mainVideoPlayer
      if (player && typeof player.getCurrentTime === 'function') {
        return player.getCurrentTime()
      }
      return this.previewCurrentTime
    },
    ...mapWindowActions({
      windowPostDeleteMessage: 'postDeleteMessage'
    }),
    ...videoSeatActions({
      getRecordById: 'getRecordById',
      validateSeat: 'validateSeat',
      saveEditorsOptions: 'saveEditorsOptions',
      cancelVideoRecord: 'cancelVideoRecord',
      deleteRecord: 'deleteRecord'
    }),
    ...editorActions({
      uploadImage: 'uploadImage',
    }),
    ...streamSeatActions({
      setOptions: 'setOptions',
      streamDeleteRecord: 'deleteRecord',
      isRecordValid: 'isRecordValid'
    }),
    ...previewMutations({
      setIsPublished: 'setIsPublished',
      setIsCanceled: 'setIsCanceled'
    }),
    validateAndSubmit: function () {
      this.isPreviewBtnDisabled = true
      this.normalizeTrimInterval()
      if (!this.is_stream) {
        this.validateSeat().then((response) => {
          const data = response.data
          if (!data.isValid) {
            router.push({ name: 'session-expired' })
          } else {
            this.formSubmit()
          }
        })
      } else {
        this.formSubmit()
      }
    },

    /**
     * @description on form submit,
     * we first upload the image get response of the server then we call saveAndPublish
     */
    formSubmit: function () {
      if (this.ffmpegData.has_watermark) {
        this.uploadImage(this.watermark_image).then(({data}) => {
          if (data.imageUrl) {
            this.ffmpegData.watermark_image_url = data.imageUrl
          }
          this.ffmpegData.watermark_image = data.image
          this.saveAndPublish()
        }).catch((error) => {
          this.isPreviewBtnDisabled = false
          let errors = error.response.data.errors
          errors = errors.map(obj => obj.msg)
          this.$notify({
            title: 'Error',
            type: 'error',
            text: errors.join()
          })
        })
      }
      else {
        this.saveAndPublish()
      }
    },

    saveAndPublish: function () {
      // we have different create api for different stream seat and video seat
      // either create the record if vide seat or update the stream seat and add the options
      if (!this.is_stream) {
        this.saveEditorsOptions(this.ffmpegData).then(() => {
          router.push({ name: 'preview' })
        }).catch((error) => {
          this.isPreviewBtnDisabled = false
          let errors = error.response.data.errors
          errors = errors.map(obj => obj.msg)
          this.$notify({
            title: 'Error',
            type: 'error',
            message: errors.join(", "),
            offset: 50
          })
        })
      } else {
        this.setOptions(this.ffmpegData).then(() => {
          // TODO: set the required params in preview
          router.push({ name: 'preview' })
        })
      }
    },

    onCancelClick: function () {
      this.$confirm.require({
        message: '',
        header: 'Save before closing?',
        icon: '',
        acceptLabel: 'Save Draft',
        rejectLabel: 'Delete',
        acceptClass: 'text-white bg-amber-500 rounded border-0 w-1/2',
        rejectClass: 'text-white bg-red-600 rounded border-0 w-1/2',
        accept: () => {
          // Save the options in database
          // to save the options we first need to save the image,
          // so we upload the image first then save options
          this.uploadImage(this.watermark_image).then(({data}) => {
            if (data.imageUrl) {
              this.ffmpegData.watermark_image_url = data.imageUrl
            }
            this.ffmpegData.watermark_image = data.image

            if (this.is_stream) {
              this.setOptions(this.ffmpegData).then(() => {
                this.$notify({
                  title: 'Success',
                  type: 'success',
                  text: 'Data Saved Successfully.'
                })
                this.windowPostDeleteMessage()
              })
            } else {
              this.saveEditorsOptions(this.ffmpegData).then(() => {
                this.$notify({
                  title: 'Success',
                  type: 'success',
                  text: 'Data Saved Successfully.'
                })
                this.windowPostDeleteMessage()
              })
            }
          }).catch(() => {
            this.$notify({
              title: 'Error',
              type: 'error',
              text: 'Something went wrong.'
            })
          })
        },
        reject: () => {
          // Cancel Session
          if (!this.is_stream) {
            // TODO: delete instead of cancel
            this.deleteRecord().then((response) => {
              const data = response.data
              if (data.success) {
                this.windowPostDeleteMessage()
              } else {
                throw new Error(data.message)
              }
            }).catch((err) => {
              this.$notify({
                title: 'Error',
                type: 'error',
                text: err.message
              })
            })
          } else {
            this.streamDeleteRecord().then((response) => {
              const data = response.data
              if (data.success) {
                this.windowPostDeleteMessage()
              } else {
                throw new Error(data.message)
              }
            }).catch((err) => {
              this.$notify({
                title: 'Error',
                type: 'error',
                text: err.message
              })
            })
          }

        }
      });
    },

    onSyncFadeToggleChange: function (val) {
      if (val == true) {
        Object.assign(this.ffmpegData.a_fade_in_model, this.ffmpegData.fade_in_model);
        Object.assign(this.ffmpegData.a_fade_out_model, this.ffmpegData.fade_out_model);
      }
    },
    toggleRightTab: function (tab) {
      this.activeRightTab = this.activeRightTab === tab ? null : tab
    },
    normalizeTrimInterval: function () {
      const duration = Number(this.ffmpegData.video_duration || 0)
      if (!Array.isArray(this.ffmpegData.trim_interval) || this.ffmpegData.trim_interval.length !== 2) {
        if (duration) {
          this.ffmpegData.trim_interval = [0, duration]
        }
        return
      }
      const start = Number(this.ffmpegData.trim_interval[0])
      const end = Number(this.ffmpegData.trim_interval[1])
      if (!duration || Number.isNaN(start) || Number.isNaN(end)) {
        return
      }
      if (start < 0 || end <= 0 || end < start) {
        this.ffmpegData.trim_interval = [0, duration]
      }
    }
  },
}
</script>

<style src="@vueform/toggle/themes/default.css"></style>

<style scoped>
.accordion-enter-active,
.accordion-leave-active {
  transition: opacity 0.18s ease, transform 0.18s ease;
}

.accordion-enter-from,
.accordion-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}
</style>
